// Module
var code = "<div class=\"landing-page-accordion\" ng-transclude=\"\"></div>\n";
// Exports
module.exports = code;